import React from 'react';

// import styled components
import {
  ConventionalFinancingContainer,
  ConventionalFinancingContentWrapper,
  ConventionalFinancingImageWrapper,
} from './styled';

// import image components
import { ConventionalFinancingCondos } from '../Images';

const ConventionalFinancing = () => (
  <section aria-label="Conventional financing">
    <ConventionalFinancingContainer>
      <ConventionalFinancingImageWrapper>
        <ConventionalFinancingCondos />
      </ConventionalFinancingImageWrapper>
      <ConventionalFinancingContentWrapper>
        <h1>Conventional Financing</h1>
        <p>
          For a condo to be eligible for the traditional conventional loan
          program, the lender will need to submit the condo for review through
          Fannie Mae (a government sponsored company that purchases mortgages
          from lenders). If it does not meet Fannie Mae's requirements, which is
          common when you're purchasing your vacation condo or second home
          condo, your traditional mortgage lender likely won't be able to offer
          you financing.
        </p>
      </ConventionalFinancingContentWrapper>
    </ConventionalFinancingContainer>
  </section>
);

export default ConventionalFinancing;
